import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllVariableTypes,
  createVariable,
  resetStatus,
} from "../../store/slices/variablesSlice";

const AddVariablePopup = ({ show, onClose, onAddVariable }) => {
  const dispatch = useDispatch();

  const [newVarName, setNewVarName] = useState("");
  const [newVarType, setNewVarType] = useState("");
  const [creating, setCreating] = useState(false);

  const variableTypes =
    useSelector(
      (state) => state.variable.listDataByKey["variableTypes"]
    ) || [];

  const loading =
    useSelector(
      (state) => state.variable.listLoadingByKey["variableTypes"]
    ) || false;

  const isSuccess = useSelector((state) => state.variable.isSuccess);
  const errorMessage = useSelector((state) => state.variable.errorMessage);

  useEffect(() => {
    if (show) {
      dispatch(fetchAllVariableTypes({ params: {}, key: "variableTypes" }));
    }
  }, [dispatch, show]);

  useEffect(() => {
    if (variableTypes.length > 0 && !newVarType) {
      setNewVarType(variableTypes[0].name);
    }
  }, [variableTypes]);

  useEffect(() => {
    if (isSuccess && creating) {
      setCreating(false);
      dispatch(resetStatus());

      onAddVariable();
      setNewVarName("");
      onClose();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (errorMessage && creating) {
      setCreating(false);
    }
  }, [errorMessage]);

  const handleApply = () => {
    if (!newVarName.trim()) return;

    const selectedType = variableTypes.find(
      (type) => type.name === newVarType
    );
    if (!selectedType) return;

    setCreating(true);

    dispatch(
      createVariable({
        variableTypeId: selectedType.id,
        name: newVarName.trim(),
        displayName: newVarName.trim(),
        dataType: "decimal",
      })
    );
  };

  if (!show) return null;

  return (
    <div className="modal_overlay" onClick={onClose}>
      <div className="modal_box" onClick={(e) => e.stopPropagation()}>
        <h5>Add Variable</h5>

        <div className="form_group">
          <label>Variable Name</label>
          <input
            className="form-control"
            value={newVarName}
            onChange={(e) => setNewVarName(e.target.value)}
          />
        </div>

        <div className="form_group">
          <label>Type</label>
          <select
            className="form-control"
            value={newVarType}
            onChange={(e) => setNewVarType(e.target.value)}
            disabled={loading}
          >
            {loading ? (
              <option>Loading</option>
            ) : (
              variableTypes.map((type) => (
                <option key={type.id} value={type.name}>
                  {type.name}
                </option>
              ))
            )}
          </select>
        </div>

        <div>
          <h6 className="text-danger">{errorMessage}</h6>
        </div>

        <div className="d-flex justify-content-end gap_14">
          <button className="btn btn_secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn_primary"
            onClick={handleApply}
            disabled={creating}
          >
            {creating ? "Creating" : "Apply"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddVariablePopup;
